module.exports = __webpack_public_path__ + "static/media/CirrusSR22.cf764f48.png";